<template>
  <v-content>
    <v-container>
      <v-alert
        v-model="show"
        v-bind="localAttrs"
        :dismissible="dismissible"
        :type="type"
        class="mb-4"
      >{{message}}</v-alert>
      <h3>Confirmation Received</h3>
      <v-btn small color="primary" v-if="nextShow" v-bind="localAttrs" :to="nextUrl">{{nextMsg}}</v-btn>
    </v-container>
    
  </v-content>
</template>
<script>
import firebase from "firebase";
export default {
  name: "userConfirm",
  data() {
    return {
      show: false,
      nextShow: false,
      message: "",
      type: null,
      nextUrl: null,
      nextMsg: null,
      border: "left",
      coloredBorder: false,
      dismissible: false,
      items: ["border", "outlined", "dense", "prominent"],
      variant: null
    };
  },
  computed: {
    localAttrs() {
      const attrs = {};

      if (this.variant === "border") {
        attrs.border = this.border;
        attrs.coloredBorder = this.coloredBorder;
      } else {
        attrs[this.variant] = true;
      }

      return attrs;
    }
  },
  created() {
    console.log("HERE IS THE ROUTE DATA: ", this.$route.query);
    let confirmData = this.$route.query;
    // IF PASSWORD CHANGE

    this.show = confirmData.show;
    this.message = confirmData.message;
    this.type = confirmData.type;
    this.nextUrl = confirmData.next_url;
    this.nextMsg = confirmData.next_msg;
    this.nextShow = confirmData.next_show;
  }
};
</script>
<style scoped>
.success-alert {
  display: block;
}
.success-alert {
  display: block;
}
</style>